export const GET_MONTHLY = 'GET_MONTHLY'
export const GET_SIZE_MONTHLY = 'GET_SIZE_MONTHLY'

export const updateMonthly = (date) => {
  return {
    type: GET_MONTHLY,
    payload: {
      date
    }
  }
}

export const updateSizeMonthly = (size) => {
  return {
    type: GET_SIZE_MONTHLY,
    payload: {
      size
    }
  }
}
